import PreviewPage from "pages/PreviewPage/PreviewPage";

export default PreviewPage;
